import React from "react";
import {KeyboardTimePicker} from "@material-ui/pickers";
import PropTypes from 'prop-types';
import {withStyles} from "@material-ui/core";
// import {withTranslation} from "react-i18next";
import i18n from "../../../i18n";
// import moment from "moment";

const styles = {
    inputBlock: {
        background: "transparent",
        borderRadius: 5,
        border: '1px solid #d1d1d1',
        "& input":{
            padding: 10
        },
        "&:hover,&.Mui-focused":{
            background: "transparent",
        },
        "&.Mui-focused+p":{
            display: "none"
        },
    },

    inputBlockError: {
        background: "transparent",
        border: '1px solid  #f80606',
        borderRadius: 5,
        "& input":{
            padding: 10
        },
        "&:hover,&.Mui-focused":{
            background: "transparent",
        },
        "&.Mui-focused+p":{
            display: "none"
        }
    },
    datePicker:{
        width: "100%",
        "&>label":{
            transform: "translate(14px, 11px) scale(1)",
            "&.MuiInputLabel-shrink":{
                display: "none"
            }
        },
        "&>$inputBlock.Mui-focused+.Mui-error":{
            display:"none"
        },
        // '& .MuiInput-underline:before': {
        //     content: 'none!important'
        // },
        // '& .MuiInput-underline:after': {
        //     content: 'none!important'
        // },
        '& .MuiInputBase-root': {
            paddingRight: 0
        }
    }
};

class AppKeyboardTimePicker extends React.Component{
    // constructor(props) {
    //     super(props);
    // }

    render() {
        const {classes,InputProps,textValidate, ...otherProps} = this.props;
        let props = {
            className: "appDatePicker "+classes.datePicker,
            margin:"none",
            variant:"dialog",
            inputVariant:"filled",
            format:"HH:mm",
            KeyboardButtonProps:{
                'aria-label': 'change date',
            },
            InputProps:{
                className: this.props.error? classes.inputBlockError: classes.inputBlock,
                disableUnderline: true,
                placeholder: i18n.t("form.timepicker.placeholder")
            },
            ampm:false,
            emptyLabel: "",
            invalidLabel: i18n.t("form.error.invalid_label"),
            invalidDateMessage: i18n.t("form.error.invalid_date"),
            maxDateMessage: i18n.t("form.error.maxDateMessage").replace("{maxDate}",""),
            minDateMessage: i18n.t("form.error.minDateMessage").replace("{minDate}",""),
            cancelLabel: i18n.t("button.cancel"),
            clearLabel: i18n.t("button.clear"),
            okLabel: i18n.t("button.ok"),
            todayLabel: i18n.t("label.today")
        };
        props = Object.assign(props,InputProps?Object.assign(props.InputProps,InputProps):{});
        props = Object.assign(props,{...otherProps});

        return <KeyboardTimePicker
            {...props}
        />;
    }
}

AppKeyboardTimePicker.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(AppKeyboardTimePicker);